
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import DatePicker from "react-datepicker";
import styled, { css } from 'styled-components';
import { fetchList } from './Details';
import Loading from '../../components/Loading';
import Api from '../../utils/Api';
import AvatarUpload from '../../components/AvatarUpload';
import { useEffect } from 'react';

const styles = css`
display: flex;
flex-direction: column;
flex-wrap: wrap;
gap: 10px;
width: 100%;
align-content: center;
> .title {
  font-size: 1.25em;
  text-align: center;
  padding: 20px;
}

 > .form {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  max-width: 600px;
  gap: 20px;
  padding: 5px;
  align-items: flex-start;

  & input {
    width: 100%;
  }
  > .row {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
    flex-wrap: wrap;
    &.avatar {
      align-content: center;
    }
    > .label {
      font-weight: bold;
    }
    & .input {
      padding-left: 5px;
      width: 100%;
    }
  }
  > .buttons {
      padding-top: 10px;
      display: flex;
      gap: 10px;
      align-self: flex-end;
    }
 }
`;
const EditList = styled(({ className }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isLoading, data: list } = useQuery(['list-edit', id], () => fetchList(id));
  const [name, setName] = useState('');
  const [eventDate, setEventDate] = useState(null);
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const isSaveable = name !== '';

  useEffect(() => {
    if (list) {
      setName(list.name);
      setDescription(list.description);
      setEventDate(new Date(list.eventDate));
      setImage(list.image);
    }
  }, [list]);

  const save = async () => {
    if (!name) return toast.error('Name is required');
    setIsUpdating(true);
    const [error,] = await Api.updateList(list._id, {
      name,
      eventDate,
      description,
      image,
    });
    setIsUpdating(false);
    if (error) {
      toast.error(Api.error(error));
      console.error(error);
    } else {
      toast.success('List updated successfully')
      navigate(-1);
    }
  }
  return (
    <Loading isLoading={isLoading}>
      {
        list &&
        <div className={className}>
          <div className='title'>
            {list.name}
          </div>
          <div className='form'>
            <div className='row'>
              <div className='label'>
                Name (required)
              </div>
              <div className='input'>
                <input value={name} placeholder='Name' onChange={e => setName(e.target.value)} />
              </div>
            </div>

            <div className='row'>
              <div className='label'>
                Event Date (optional)
              </div>
              <DatePicker selected={eventDate} onChange={(date) => setEventDate(date)} />
            </div>

            <div className='row'>
              <div className='label'>
                Description (optional)
              </div>
              <div className='input'>
                <input value={description} placeholder='Description' onChange={e => setDescription(e.target.value)} />
              </div>
            </div>

            <div className='row avatar'>
              <div className='label'>
                Image (optional)
              </div>
              <AvatarUpload avatar={image} onUploaded={setImage} />
            </div>
            <div className='buttons'>
              <button className='danger' onClick={() => navigate(-1)}>Cancel</button>
              <button disabled={!isSaveable || isUpdating} className='primary' onClick={save}>Save</button>
            </div>
          </div>
        </div>
      }
    </Loading>
  )
})`${styles}`;

export default EditList;